<template>
    <div class="mt-8">
        <div>
            <p class="text-main-color">カード番号</p>
            <FormInput :value="value.cardno"
                       @input="e => onChange('cardno', e)"
                       class="w-full lg:w-500p max-w-full"
                       autocomplete="cc-number"
                       maxlength="19"/>
            <ErrorText :errors="errors" name="cardno"/>
            <div class="mt-2">
                <BrandLogos/>
            </div>
        </div>
        <div class="mt-4">
            <p class="text-main-color">有効期限</p>
            <CardExpireInput :value="value.expire"
                             @input="e => onChange('expire', e)"/>
        </div>
        <div class="mt-4">
            <p class="text-main-color">セキュリティコード</p>
            <FormInput
                :value="value.securitycode"
                @input="e => onChange('securitycode', e)"
                class="w-full lg:w-200p"
                autocomplete="cc-csc"
                maxlength="4"
            />
            <div class="mt-2">
                <SecurityCodeInformation/>
            </div>
        </div>
        <div class="mt-4">
            <p class="text-main-color">お支払い回数</p>
            <FormInput type="select" class="w-full lg:w-200p"
                       @input="e => onChangePayTimes(e)"
                       :value="payTimes"
                       :options="payTimesList"/>
            <ErrorText :errors="errors" name="pay_times"/>
        </div>
    </div>
</template>

<script>
import FormGroup from "./FormGroup.vue";
import BrandLogos from "../app/BrandLogos.vue";
import FormLabel from "./FormLabel.vue";
import CardExpireInput from "../app/CardExpireInput.vue";
import SecurityCodeInformation from "../app/SecurityCodeInformation.vue";
import ErrorText from "../ErrorText.vue";
import FormInput from "../app/FormInput.vue";

export default {
    name: "CreditForm",
    components: {ErrorText, FormInput, SecurityCodeInformation, CardExpireInput, FormLabel, BrandLogos, FormGroup},
    props: {
        value: {
            type: Object,
        },
        errors: {
            type: Object | Array
        },
        payTimes: {
            type: String | Number
        }
    },

    computed: {
        payTimesList() {
            return [
                {
                    value: 1,
                    label: '1回'
                },
                {
                    value: 'bonus',
                    label: 'ボーナス払'
                }
            ]
        },
    },

    methods: {
        onChange(type, e) {
            this.$emit('input', {
                ...this.value,
                [type]: e
            })
        },

        onChangePayTimes(e) {
            this.$emit('onChangePayTimes', e)
        }
    }
}
</script>

<style scoped>

</style>
